/**
 * IssuesRunsPage — „Läufe & Review" im PIM (P1/B4). Dünner Mount:
 * Header + IssuesAreaTabs + bestehende RunsListSection (Reuse, Tool unverändert).
 */
import { useTranslation } from 'react-i18next'

import { IssuesAreaTabs } from '@/components/v2/products/issues/IssuesAreaTabs'
import { RunsListSection } from '@/components/v2/tools/text-bulk'

export function IssuesRunsPage() {
  const { t } = useTranslation()
  return (
    <div className="flex h-full flex-col gap-6 p-6">
      <header>
        <h1 className="text-2xl font-bold text-neutral-900 dark:text-neutral-100">
          {t('productsIssues.title')}
        </h1>
      </header>
      <IssuesAreaTabs />
      <RunsListSection runLinkBase="/v2/products/issues/runs" />
    </div>
  )
}
